<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    width="840px"
    append-to-body
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    @closed="handleClosed">
    <el-form
      ref="ruleForm"
      :validate-on-rule-change="false"
      :model="ruleForm"
      :rules="rules"
      label-width="100px">
      <el-form-item
        label="机构名称："
        prop="servOrgName">
        <el-input
          v-model="ruleForm.servOrgName"
          show-word-limit
          :maxlength="32"></el-input>
      </el-form-item>
      <el-form-item
        label="排序值："
        prop="sortNumber">
        <el-input-number
          v-model="ruleForm.sortNumber"
          :precision="0"
          :min="1"
          :max="100"></el-input-number>
      </el-form-item>
      <el-form-item
        label="机构首图："
        prop="image">
        <upload-with-crop
          v-model="ruleForm.image"
          :cropper="true"
          :isLt2M="500"
          :limit="1"
          :fixedNumber="[5,3]"
          :autoCropWidth="120"
          :autoCropHeight="72"></upload-with-crop>
      </el-form-item>
      <el-form-item
        label="机构简介："
        prop="introduction">
        <el-input
          v-model="ruleForm.introduction"
          type="textarea"
          show-word-limit
          :maxlength="150"
          :autosize="{ minRows: 2, maxRows: 4}"></el-input>
      </el-form-item>
      <el-form-item
        label="机构地址："
        prop="address">
        <el-input
          v-model="ruleForm.address"
          type="textarea"
          show-word-limit
          :maxlength="50"
          :autosize="{ minRows:2, maxRows: 4}"></el-input>
      </el-form-item>
      <el-form-item
        label="联系方式："
        prop="contactPhone">
        <el-input
          v-model="ruleForm.contactPhone"
          show-word-limit
          :maxlength="20"></el-input>
      </el-form-item>
      <el-form-item
        label="机构官网："
        prop="homepage">
        <el-input
          v-model="ruleForm.homepage"
          show-word-limit
          :maxlength="100"></el-input>
      </el-form-item>
      <el-form-item
        label="机构详情："
        prop="contentImages">
        <desc-images
          v-model="ruleForm.contentImages"
          edit></desc-images>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button
        :loading="loading"
        @click="visible = false">取 消</el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSubmit">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import DescImages from '../../../components/public/desc-images.vue'
import UploadWithCrop from '../../../components/public/upload-with-crop.vue'
import OrgService from '@/service/org-service'
export default {
  name: 'EditOrgModal',
  components: { DescImages, UploadWithCrop },
  data() {
    return {
      loading: false,
      visible: false,
      ruleForm: { id: null, servOrgName: '', image: [], introduction: '', sortNumber: 1, address: '', contactPhone: '', homepage: '', contentImages: [], adminAccount: Math.random() },
      rules: {
        servOrgName: [
          { required: true, message: '请输入机构名称', trigger: 'blur' }
        ],
        image: [
          { required: true, message: '请上传机构首图', trigger: 'change' }
        ],
        homepage: [
          { required: false, type: 'url', message: '请输入官网', trigger: 'change' }
        ],
        introduction: [
          { required: true, message: '请输入机构简介', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '请输入机构地址', trigger: 'blur' }
        ],
        contactPhone: [
          { required: true, message: '请输入联系方式', trigger: 'blur' }
        ],
        contentImages: [
          { required: true, message: '请上传机构详情图片', trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    title({ ruleForm }) {
      return (ruleForm.id ? '编辑' : '新增') + '合作机构'
    }
  },
  methods: {
    handleClosed() {
      this.ruleForm = { ...this.ruleForm, ...this.$options.data().ruleForm }
    },
    handleSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loading = true
          const { contentImages, image, id } = this.ruleForm
          const dispatch = id ? 'updateservorg' : 'addservorg'
          OrgService[dispatch]({
            ...this.ruleForm,
            image: this.$stringfyImage(image),
            contentImages: this.$stringfyImage(contentImages)
          })
            .then(res => {
              this.loading = false
              const { result, message } = res.data
              if (result === 0) {
                this.visible = false
                this.$message.success('提交成功')
                this.$emit('fetch')
              } else {
                this.$message.error(message)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error(err.message)
            })
        }
      })
    },
    init(options = {}) {
      const { contentImages, image } = options
      this.ruleForm = { ...this.ruleForm, ...options, contentImages: this.$splitImage(contentImages), image: this.$splitImage(image) }
      this.visible = true
    }
  }
}
</script>
